import { render, staticRenderFns } from "./wlgz.vue?vue&type=template&id=396a11c6&scoped=true&"
import script from "./wlgz.vue?vue&type=script&lang=js&"
export * from "./wlgz.vue?vue&type=script&lang=js&"
import style0 from "./wlgz.vue?vue&type=style&index=0&id=396a11c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a11c6",
  null
  
)

export default component.exports